import { render, staticRenderFns } from "./BancaEmaticaRichiesteRepartoList.vue?vue&type=template&id=d895c30c"
import script from "./BancaEmaticaRichiesteRepartoList.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRichiesteRepartoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports